<app-header
  [enableBack]="false"
  [navItems]="navItems">
  <div title>
    {{ 'settlement.title' | translate }}
  </div>
</app-header>

<div class="p-6">
  <router-outlet></router-outlet>
</div>
